















import {Component, Vue, Prop} from 'vue-property-decorator';
import {isMobile, PhotoLibrary} from '@/scripts';

@Component
export default class AlbumView extends Vue {
  @Prop() public index!: number;
  public library = PhotoLibrary;
  public isMobile = isMobile;
}
